<template>
	<div class="chuzulv2">
		<!-- 修改：使用grid布局实现三行三列 -->
		<div class="one-kuan" v-for="(item,index) in list" :key="index" @click="setupChartClick(item,'shuju')">
			<div class="card-type">
				<!-- <div class="dian"></div> -->
				{{item.title}}
			</div>
			<div v-if="item.subNum !== undefined" class="num-row">
				<span class="number">{{item.num}}<span class="danwei">{{item.danwei}}</span></span>
				<span class="number sub-num">{{item.subNum}}<span class="danwei">{{item.subDanwei}}</span></span>
			</div>
			<div v-else class="number">{{item.num}}<span class="danwei">{{item.danwei}}</span></div>
		</div>
	</div>
</template>

<script>
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入点击事件
	import apis from "@/http/apis";
	import { dedupeEquityByAssetName, getEquityHoldPanels } from './equity-detail-filter';

	export default {
		name: 'RingChart',
		mixins: [chartClickMixin],
		data() {
			return {
				chart: null,
				list: [
					{ title: "管理资产总数",       num: "--", danwei: "个"   },
					{ title: "确权资产价值",     num: "--", danwei: "万元" },
					{ title: "累计营收总额",       num: "--", danwei: "万元" },
					{ title: "存量资产总数",   num: "--", danwei: "个"   },
					{ title: "参股公司总数", num: "--", danwei: "个"   },
					{ title: "不良资产总计", num: "--", danwei: "户" },
				]
			};
		},
		created() {
			this.fetchData();
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
		},
		methods: {
			fetchData() {
				Promise.all([
					apis.todayData().catch((err) => { console.error('数据概览接口请求失败', err); return {}; }),
					apis.assetRevenue().catch((err) => { console.error('资产营收接口请求失败', err); return {}; }),
					apis.equityShareholderRatio().catch((err) => { console.error('股东占股比例接口请求失败', err); return {}; }),
					apis.stockAssetList().catch((err) => { console.error('存量资产列表接口请求失败', err); return {}; }),
					apis.equityAssetList().catch((err) => { console.error('股权资产列表接口请求失败', err); return {}; }),
					apis.nonPerformingAssetList().catch((err) => { console.error('不良资产列表接口请求失败', err); return {}; }),
					apis.assetRentalRate().catch((err) => { console.error('资产出租率接口请求失败', err); return {}; }),
					apis.kpiConfig().catch((err) => { console.error('KPI配置接口请求失败', err); return {}; }),
				]).then(([todayRes, revenueRes, shareholderRes, stockListRes, equityListRes, badListRes, rentalRes, kpiRes]) => {
					console.log('[数据概览] 接口返回数据:', todayRes);
					const d = todayRes && todayRes.data ? todayRes.data : {};
					const r = revenueRes && revenueRes.data ? revenueRes.data : {};
					const shareholderList = (shareholderRes && shareholderRes.data && shareholderRes.data.list ? shareholderRes.data.list : [])
						.filter(item => item.shareholdersName !== '枣庄市财金控股集团有限公司');
					// 用与弹框相同的三个 list 接口实际条数计算总数，保证数据一致
					const stockList  = (stockListRes  && stockListRes.data  && stockListRes.data.list)  ? stockListRes.data.list  : [];
					const equityListRaw = (equityListRes && equityListRes.data && equityListRes.data.list) ? equityListRes.data.list : [];
					const equityPanels = getEquityHoldPanels(equityListRaw);
					const equityList = dedupeEquityByAssetName(equityListRaw);
					const badList    = (badListRes    && badListRes.data    && badListRes.data.list)    ? badListRes.data.list    : [];
					const assetTotal = stockList.length + equityPanels.holdCount + badList.length;
					// 累加出租率接口中的大类（地块）和小类（位置）数量
					const rentalList = (rentalRes && rentalRes.data && rentalRes.data.list) ? rentalRes.data.list : [];
					const totalDikuai = rentalList.reduce((sum, item) => sum + (item.value || 0), 0);
					const totalWeizhi = rentalList.reduce((sum, item) => sum + (item.locationCount || 0), 0);
					// 从 kpiConfig 接口提取五个可调整字段
					const kpiList = (kpiRes && kpiRes.data && kpiRes.data.list) ? kpiRes.data.list : [];
					const kpiMap = {};
					kpiList.forEach(item => { kpiMap[item.fieldKey] = item.fieldValue; });
					this.list = [
						{ title: "资产总数",       num: assetTotal,               danwei: "个"   },
						{ title: "管理资产总规模",     num: kpiMap['asset_total_scale'] != null ? Number(kpiMap['asset_total_scale']).toFixed(2) : "--", danwei: "亿元" },
						{ title: "2026营收总额",       num: kpiMap['revenue_total']     != null ? Number(kpiMap['revenue_total']).toFixed(2)     : "--", danwei: "万元" },
						{ title: "存量资产总数",   num: totalDikuai,  danwei: "处" },
						{ title: "股权资产持有数", num: equityPanels.holdCount,        danwei: "个"   },
						{ title: "不良资产总户数", num: badList.length,           danwei: "户"   },
					];
				});
			},
		}
	};
</script>
<style scoped>
	.chuzulv2 {
		width: 100%;
		height: 100%;
		display: grid;
		padding: 20px;
		gap: 5px;
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: repeat(2, 1fr);
		box-sizing: border-box;
	}

	.one-kuan {
		/* 修改：每个格子使用flex垂直布局 */
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.one-kuan :hover {
		cursor: pointer;
	}


	.card-type {
		font-weight: 600;
		font-size: 2vh;
		color: #07e1ff;
		display: flex;
		align-items: center;
		/* margin-bottom: 10px; */
		/* 增加与数字的间距 */
		text-align: center;
	}

	.dian {
		width: 10px;
		height: 10px;
		margin-right: 8px;
		border-radius: 50%;
		/* 使用50%实现正圆形 */
		background-color: #07e1ff;
		flex-shrink: 0;
		/* 防止被压缩 */
	}

	.number {
		font-size: 2.3vh;
		color: #fff;
		font-weight: 600;
		text-align: center;
		margin-left: 0px;
	}

	.num-row {
		display: flex;
		flex-direction: row;
		align-items: baseline;
		justify-content: center;
		gap: 8px;
	}

	.sub-num {
		font-size: 1.8vh;
		color: #07e1ff;
	}

	.danwei {
		font-size: 1.5vh;
		color: rgb(255, 255, 255, 0.7);
		margin-left: 5px;
		font-weight: 500;
	}


	/* 响应式调整：在小屏幕上改为两列 */
	@media (max-width: 768px) {
		.chuzulv2 {
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(5, 1fr);
		}
	}

	/* 在更小的屏幕上改为单列 */
	@media (max-width: 480px) {
		.chuzulv2 {
			grid-template-columns: 1fr;
			grid-template-rows: repeat(9, 1fr);
		}
	}
</style>